export default __webpack_public_path__ + "static/media/09-marina-gallo-ophiuchus-jewels-paine-chile-travel-diary.92a7cba7.jpg";